import {Rank} from '@types';

interface RankProps {
    rank?: Rank;
    showMark?: boolean;
    shortUnit?: boolean;
    camelCase?: boolean;
}
const RankText = ({rank, showMark = true, shortUnit = false}: RankProps) => {
    if (showMark && (rank === null || rank === undefined)) {
        return <span>?</span>;
    }

    if (!rank) {
        return null;
    }

    let unit = ` ${rank.unit.toString()}`;
    if (shortUnit) {
        unit = `${rank.unit.toString().charAt(0)}`;
    }

    return (
        rank && (
            <span>
                {rank.value}
                {unit}
                {showMark && rank.mark && '?'}
            </span>
        )
    );
};

export default RankText;
